import { Link, getProductUrl } from "@/shared";
import { cn } from "@dafiti/closet-ui/utils";

import type {
  CatalogMetaResponse,
  CatalogProduct,
} from "../../../types/catalog.type";
import { CatalogProductCard } from "../CatalogProductCard/CatalogProductCard";

type Props = {
  products: CatalogProduct[];
  meta?: CatalogMetaResponse;
  isLoading?: boolean;
};

export const gridClasses = cn(
  "grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-2 lg:gap-6 gap-y-8",
);

export function CatalogGrid({ products, meta, isLoading }: Props) {
  return (
    <div
      className={cn(
        gridClasses,
        isLoading && "opacity-60 transition-opacity duration-300",
      )}
      data-testid="catalog-grid"
    >
      {products.map((product, index) => (
        <Link
          useRouterLink
          key={product.sku}
          href={getProductUrl(product.url) || "/"}
          prefetch={index < 5}
        >
          <CatalogProductCard product={product} index={index} meta={meta} />
        </Link>
      ))}
    </div>
  );
}
